import apiService from "./apiServices";

export const saveLocationGroups = async(formData, token) => {

    try {
        const response = await apiService('/locationgroups/save', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving location is failed. Please try again.');
        }
  }

  export const updateLocationGroups = async (formData, token) => {
    try {

      const response = await apiService('/locationgroups/update', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Updating location is failed. Please try again.');
      }
  }

  export const getAllLocationGroups = async (token,page ,size) => {
    try {

      const response = await apiService(`/locationgroups/all-groups?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }



  export const getlocationGroupsById = async (id, token) => {
    try {
      const response = await apiService(`/locationgroups/${id}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const deletelocationGroupsById = async (token, id) => {
    try {
      const response = await apiService(`/locationgroups/delete/${id}`, 'DELETE', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const getlocationGroups = async (token,page, size) => {
    try {
        const response = await apiService(`/locationgroups/all?page=${page}&size=${size}`, 'GET', null, null, token);
        return response;
      } catch (error) {
        throw (error?.message || 'service is failed. Please try again.');
      }
  }


  export const getAllLocationGroupsList = async (token,page ,size) => {
    try {

      const response = await apiService(`/locationgroups/paginated-groups?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }
